const QuoteList = () => {
  return <div id="quoteAi"></div>;
};

export default QuoteList;
